import React from "react";
import PropTypes from "prop-types";
import DellyCnv from "../models/DellyCnv";
import { precisionLabels } from "../../../constants/dellyPrecision";
import { pathogenicityLabelsLong } from "../../../constants/pathogenicity";
import { cnvTypeLabels } from "../../../constants/cnvTypes";
import Track from "../../../models/Track";

function DellyCnvTitle(props) {
  const { item, actions, track } = props;
  const trackState = track.getState() || {};
  const chr = item.region.chromosome;
  return item ? (
    <>
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          {chr.name}:{item.region.x0}..{item.region.x1}
        </div>
        {actions}
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Pathogenicity</div>
        <div className="tw-flex-grow">
          <div
            className="tw-h-2 tw-w-2 tw-mr-2 tw-rounded-full tw-inline-block"
            style={{ backgroundColor: trackState.colors[item.pathoIndex] }}
          />
          {pathogenicityLabelsLong[item.pathoIndex]}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Read Ratio (Obs/Exp)</div>
        <div className="tw-flex-grow">
          {Math.round(item.readratio * 100) / 100}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Type</div>
        <div className="tw-flex-grow">{cnvTypeLabels[item.typeIndex]}</div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Delly Precision</div>
        <div className="tw-flex-grow">
          {precisionLabels[item.precisionIndex]}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Start Position</div>
        <div className="tw-flex-grow">
          {item.region.chromosome.name}: {item.region.x0.toLocaleString()}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">End Position</div>
        <div className="tw-flex-grow">
          {item.region.chromosome.name}: {item.region.x1.toLocaleString()}
        </div>
      </div>
      {/* <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">
          ciPos / ciEnd
          <i
            className="fa fa-info-circle tw-mx-1 tw-text-xs tw-text-gray-500 tw-relative"
            data-tooltip="Confidence interval for the start and end positions"
          />
        </div>
        <div className="tw-flex-grow">± {Math.abs(item.ciPos)}</div>
      </div> */}
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Call Length</div>
        <div className="tw-flex-grow">
          {(item.region.g1 - item.region.g0).toLocaleString()}
        </div>
      </div>
    </>
  ) : null;
}

DellyCnvTitle.propTypes = {
  item: PropTypes.instanceOf(DellyCnv).isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
  actions: PropTypes.node,
};

DellyCnvTitle.defaultProps = {
  actions: null,
};

export default DellyCnvTitle;
